import React from 'react';
import useGetListById from 'Hooks/query-hooks/list/useGetListById';
import { addAdditionalBreadcrumbParams } from 'Store';

import { getEmptyStringReplacementText, getPathnameAtLevel } from 'Utils';
import { useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// for all routes related to a singe list
// we need to be able to set the breadcrumb for the list name
// so this hook will do that and return the GET query
function useGetSingleListAndSetBreadcrumb(users?: UsersHashmap) {
    const { id } = useParams<{ id: string }>();
    const query = useGetListById(Number(id), users);
    const location = useLocation();
    const dispatch = useDispatch();

    React.useEffect(() => {
        const pathname = getPathnameAtLevel(location.pathname, 2);
        dispatch(
            addAdditionalBreadcrumbParams({
                pathname,
                params: {
                    listName: getEmptyStringReplacementText(query.data?.name)
                }
            })
        );
    }, [query.status, id, dispatch, location.pathname, query.data]);

    return {
        query,
        listId: Number(id)
    };
}

export default useGetSingleListAndSetBreadcrumb;
